import type { SetState } from 'zustand';
import type { OverstockItemProps } from '@product/BuyBox/Default/ChainflexOverstockSale/ChainflexOverstockSale';
import type { ProductPageStore } from './useProductPageStore';

export type OverstockSaleSliceData = {
  selectedChainflexOverstockItem: OverstockItemProps | null;
};

export interface OverstockSaleSlice extends OverstockSaleSliceData {
  setSelectedChainflexOverstockItem: (data: OverstockItemProps) => void;
  resetSelectedChainflexOverstockItem: () => void;
}

export const createOverstockSaleSlice = (set: SetState<ProductPageStore>) =>
  ({
    selectedChainflexOverstockItem: null,
    setSelectedChainflexOverstockItem: data => {
      set(state => ({
        ...state,
        selectedChainflexOverstockItem: data,
      }));
    },
    resetSelectedChainflexOverstockItem: () => {
      set(state => ({
        ...state,
        selectedChainflexOverstockItem: null,
      }));
    },
  } as OverstockSaleSlice);
